module.exports = __webpack_public_path__ + "static/media/29FUNOV7.3e2c73a1.jpg";